import React from "react";
import {
  Button,
  CloseIcon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from "../../styles/MaterialUI";

const PreviewContent = ({ previewContent, onClose }) => {
  const { openPreview, contentType, chooseFit, previewData } = previewContent;
  const imageSrc = `data:image/jpeg;base64,${previewData}`;
  const dashboardSrc = previewData;

  return (
    // <div>
    <Dialog
      open={openPreview}
      onClose={onClose}
      fullWidth
      maxWidth={contentType === "Image" ? "xs" : "md"}
      fullScreen={contentType !== "Image"}
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 1,
          pl: 2,
          pr: 2,
          color: "white",
          backgroundColor: "#003366",
        }}
      >
        Content Preview
        <IconButton
          aria-label="close"
          onClick={onClose}
          style={{ float: "right", color: "gray" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid container item xs={12} sx={{ padding: '10px', width: '100%', maxHeight: '100vh', }}>
          {contentType === "Image" ?
            <img
              src={imageSrc}
              alt="Preview"
              style={{
                width: '100%',
                height: '100%',
                objectFit:
                  chooseFit === "Fill" || chooseFit === "Stretch"
                    ? "fill"
                    : chooseFit === "Fit"
                      ? "contain"
                      : "fill",
              }}
            /> :
            <div style={{ width: "100%" }} dangerouslySetInnerHTML={{ __html: dashboardSrc }} />
          }
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          size="small"
          color="info"
          onClick={onClose}
          style={{ textTransform: "none", marginRight: "20px" }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
    // </div>
  );
};

export default PreviewContent;
